import { useState, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Loading from "components/Loading";
import moment from "moment";
import { ReactTableDataGrid } from "components/Table";
import { getLeaderboard } from "actions/spyAdvancedActions";
import { getQueryParams } from "components/Function";
import useCallApi from "hook/useCallApi";
import SpyFilter from "../../filter";
import { heightRow, CATEGORIES } from "../../constant";
import useColumnTableProductNew from "../../hooks/useColumnTableProductNew";

const limit = 20;

const TabNew = ({ getLeaderboard }) => {
    const { filter: initialFilter, page: initialPage } = getQueryParams();

    const [filter, setFilter] = useState(initialFilter);
    const [page, setPage] = useState(initialPage);

    const params = useMemo(() => {
        if (!filter?.time_type) filter.time_type = "daily";
        if (!filter?.time_range) filter.time_range = moment().subtract(1, "days").format("YYYYMMDD");
        filter.type = "news-burst";
        return { ...filter, page, per_page: limit };
    }, [filter, page]);
    const { data, loading } = useCallApi(getLeaderboard, params);

    const columns = useColumnTableProductNew(heightRow);

    useEffect(() => {
        const cleanedFilter = Object.fromEntries(Object.entries(filter).filter(([_, value]) => value));
        const params = new URLSearchParams({ ...cleanedFilter, page });
        window.history.replaceState({}, "", `${window.location.pathname}?${params.toString()}`);
    }, [filter, page]);

    const onTableChanged = ({ page }) => {
        if (page) setPage(page);
    };

    return (
        <div className="card mb-5 mb-xl-10">
            <Loading isLoading={loading} />
            <div className="card-body">
                <div className="row mb-10">
                    <div className="col-md-4 d-flex align-items-center">
                        <h1 className="mb-0">New Products</h1>
                    </div>
                    <div className="col-md-8 position-relative"></div>
                </div>
                <div className="d-flex align-items-center gap-10 mb-8">
                    <label className="form-label" style={{ minWidth: "130px", textAlign: "right" }}>
                        Shelf Time
                    </label>
                    <DateRangePicker
                        onCallback={(value) => {
                            setFilter((prev) => ({
                                ...prev,
                                time_range: value.format("YYYYMMDD"),
                            }));
                        }}
                        initialSettings={{
                            showDropdowns: true,
                            locale: { format: "DD/MM/YYYY" },
                            maxDate: moment().subtract(1, "days").toDate(),
                            singleDatePicker: true,
                            startDate: moment().subtract(1, "days").toDate(),
                        }}
                    >
                        <input type="text" className="form-control al-form-control-daterangepicker" />
                    </DateRangePicker>
                </div>
                <SpyFilter
                    filter={filter}
                    filterCategory={[
                        {
                            label: "Product Category",
                            key: "product_categories",
                            data: CATEGORIES,
                        },
                    ]}
                    setFilter={(data) => {
                        setFilter(data);
                        setPage(1);
                    }}
                    filterShows={[{ label: "Region", value: "region", defaultValue: "US" }]}
                />
                <div className="mt-10">
                    <ReactTableDataGrid
                        tableName="productSpyAdvancedNew"
                        idProperty="_id"
                        columns={columns}
                        rowData={data?.data || []}
                        pageNumber={page}
                        gridOptions={{
                            rowHeight: heightRow,
                            reactiveCustomComponents: true,
                        }}
                        paginationPageSize={limit}
                        totalSize={data?.meta?.total || 0}
                        emptyText={"No data!"}
                        isSearchText={false}
                        onTableChanged={onTableChanged}
                    />
                </div>
            </div>
        </div>
    );
};

export default connect(null, { getLeaderboard })(TabNew);
